// utils/cardUtils.ts
import masterCardImage from '../../../assets/paymentCardImages/mastercard.svg';
import americanExpressCardImage from '../../../assets/paymentCardImages/american-express.svg';
import VisaCardImage from '../../../assets/paymentCardImages/visa.svg';
import discoverCardImage from '../../../assets/paymentCardImages/discover.svg';

const cardTypeImages: { [key: string]: string } = {
  discover: discoverCardImage,
  visa: VisaCardImage,
  'american-express': americanExpressCardImage,
  mastercard: masterCardImage
};

export const cardUtils = {
  formatCardNumber: (value: string): string => {
    const cleaned = value.replace(/\D/g, '');
    const formatted = cleaned.replace(/(\d{4})(?=\d)/g, '$1 ');
    return formatted;
  },

  getCardType: (creditCardNumber: string): string | null => {
    if (creditCardNumber.startsWith('4')) return 'visa';
    if (creditCardNumber.startsWith('5') || creditCardNumber.startsWith('2'))
      return 'mastercard';
    if (creditCardNumber.startsWith('3')) return 'american-express';
    if (creditCardNumber.startsWith('6')) return 'discover';
    return null;
  },

  getCardTypeLogo: (cardType: string): string | null => {
    return cardTypeImages[cardType] || null;
  },

  validateCardNumber: (cardNumber: string): boolean => {
    const cleaned = cardNumber.replace(/\D/g, '');
    return cleaned.length === 16;
  },

  formatExpiryDate: (value: string): string => {
    const cleaned = value.replace(/\D/g, '');
    let formatted = cleaned;
    if (cleaned.length > 2) {
      formatted = `${cleaned.substring(0, 2)}/${cleaned.substring(2, 4)}`;
    }
    return formatted.substring(0, 5);
  },

  validateExpiryDate: (expiryDate: string): boolean => {
    const regex = /^(0[1-9]|1[0-2])\/\d{2}$/;
    if (!regex.test(expiryDate)) return false;

    const [month, year] = expiryDate.split('/');
    const expiryMonth = parseInt(month, 10);
    const expiryYear = parseInt(year, 10);
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear() % 100;
    const currentMonth = currentDate.getMonth() + 1;

    if (expiryYear < currentYear) return false;
    if (expiryYear === currentYear && expiryMonth < currentMonth) return false;

    return true;
  },

  validateCvv: (cvv: string, cardType: string): boolean => {
    if (cardType === 'american-express') return cvv.length === 4;
    return cvv.length === 3;
  },

  preciseToFixed: (value: number, decimals: number): string => {
    const factor = Math.pow(10, decimals);
    return (Math.round(value * factor) / factor).toFixed(decimals);
  }
};